import compact from 'lodash/compact';
import { getMessengerSource } from 'src/utils';
import { chatgenieAPI } from './chatgenieApi';

export const fetchTicketNotes = ({ ticketId }) =>
  chatgenieAPI.tickets.fetchNotes(ticketId).then(({ data: { data } }) => data);

export const addTicketNote = ({ text, ticketId }) => chatgenieAPI.tickets.createNote(ticketId, text);

export const fetchTickets = (nextPage, { userId, filter }) => {
  const filterTxt = filter === 'All' ? '' : filter;

  return chatgenieAPI.tickets.fetchByContact(nextPage, userId, filterTxt).then(({ data }) => data);
};

export const getMyDevices = (nextPage, { userId, role, companyId }) => {
  // Disabled until we implement site contact support
  // if (role === 'admin') {
  //   return chatgenieAPI.devices.fetchByCompany(nextPage, companyId).then(({ data }) => data);
  // }
  return chatgenieAPI.devices.fetchByContact(nextPage, userId).then(({ data }) => data);
};

export const reportDeviceService = ({ payload }) => {
  const source = getMessengerSource();
  return chatgenieAPI.createTicket({ ...payload, source }).then(({ data: { data } }) => data);
};

export const submitDeviceConfiguration = ({ ticketId, payload }) =>
  chatgenieAPI.devices.attach(ticketId, payload).catch((err) => console.log(err));

export const getTicketConfigurations = ({ ticketId }) => {
  try {
    return chatgenieAPI.tickets.fetchDevices(ticketId).then(async ({ data: { data } }) => {
      const devices = await Promise.all(
        data?.map(async (configuration) => {
          try {
            const {
              data: { data: device },
            } = await chatgenieAPI.devices.fetchById(configuration.id);
            return device;
          } catch (err) {
            return null;
          }
        }),
      );
      return compact(devices);
    });
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const getCompanyContacts = ({ companyId }) =>
  chatgenieAPI.getCompanyContacts(companyId).then(({ data: { data } }) => data);
